import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SeminarManagementViewer';

const getListSeminarViewerReducer = handleActions({
    [Actions.GetListSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const detailSeminarViewerReducer = handleActions({
    [Actions.GetDetailSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearDetailSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});
const getListSeminarViewerNonAuthReducer = handleActions({
    [Actions.GetListSeminarNonAuthRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListSeminarNonAuthReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListSeminarNonAuthReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListSeminarNonAuth]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const detailSeminarViewerNonAuthReducer = handleActions({
    [Actions.GetDetailSeminarNonAuthRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailSeminarNonAuthReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailSeminarNonAuthReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearDetailSeminarNonAuth]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});
const registerSeminarViewerReducer = handleActions({
    [Actions.RegisterSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.RegisterSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        registerStatus: action.payload.status,
        data: action.payload,
    }),
    [Actions.RegisterSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearRegisterSeminar]: () => ({
        isFetching: false,
        data: {},
        registerStatus: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    registerStatus: false,
    errors: {},
});

const INITIAL_LIST_SEMINAR_PAUSED = {
    isFetching: false,
    data: {},
    success: false,
    errors: {},
};

const getListSeminarPausedReducer = (state = INITIAL_LIST_SEMINAR_PAUSED, action) => {
    switch (action.type) {
        case 'GET_LIST_SEMINAR_PAUSED_REQUESTED':
            return {
                ...state,
                isFetching: true,
            };
        case 'GET_LIST_SEMINAR_PAUSED_REQUESTED_RECEIVED':
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                success: true,
            };
        case 'GET_LIST_SEMINAR_PAUSED_REQUESTED_RECEIVED_FAILURE':
            return {
                ...state,
                isFetching: true,
                errors: action.payload,
            };
        case 'CLEAR_LIST_SEMINAR_PAUSED':
            return {
                ...state,
                ...INITIAL_LIST_SEMINAR_PAUSED,
            };
        default:
            return state;
    }
};

export default combineReducers({
    listSeminarViewer: getListSeminarViewerReducer,
    listSeminarNonAuthViewer: getListSeminarViewerNonAuthReducer,
    detailSeminarViewer: detailSeminarViewerReducer,
    detailSeminarNonAuthViewer: detailSeminarViewerNonAuthReducer,
    registerSeminarViewer: registerSeminarViewerReducer,
    listSeminarPaused: getListSeminarPausedReducer,
});
